export const name = "IS_NAN";
export const summary = `Checks if \`X\` is a \`NaN\` value.`;
export const reference = `
## IS_NAN

Checks if \`X\` is a \`NaN\` value.

\`\`\`
IS_NAN(X)
\`\`\`

### Description

Returns \`TRUE\` if the value is a \`NaN\` value.

| X | IS\\_NAN(X) |
| --- | --- |
| \`NaN\` | \`TRUE\` |
| 25 | \`FALSE\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
